import React from 'react'
import '../styles/Slider.css'
function Slider() {
  return (
    <aside className='Slider'>
        <div></div>
    </aside>
  )
}

export default Slider